// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import instance from "../../store/axios";
import { LOADING } from "../../store/actions";

class FundService {
  private dispatch = useDispatch();

  public async getFundListData(): Promise<any[] | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<{
        data: any[];
        message: string;
      }> = await instance.get(`/${process.env.REACT_APP_ENDPOINT_VERSION}/option/mutual-funds`);
      return response.data.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/funds`);
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}

export default FundService;
